module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "nav-with-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item is-brand",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/cm-logo.svg",
      "alt": "Chillout Music"
    }
  }), _vm._v("  Chillout Music\n          ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-toggle",
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: {
      'is-active': _vm.isHamburgerActive
    },
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/rdj",
      "exact": ""
    }
  }, [_vm._v("Residents DJs")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/rules",
      "exact": ""
    }
  }, [_vm._v("Rules")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/bot"
    }
  }, [_vm._v("Bot")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/triggers",
      "exact": ""
    }
  }, [_vm._v("Triggers")]), _vm._v(" "), _vm._m(0)], 1)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "https://plug.dj/electronic-chillout-music",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Join us on Plug.dj")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('p', [_vm._v("Chillout Music © 2014-2019")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "position": "relative",
      "left": "-13px"
    }
  }, [_c('a', {
    staticClass: "facebook",
    attrs: {
      "href": "https://www.facebook.com/chilloutmusic.fm",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "https://www.twitter.com/chilloutmusica",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "reddit",
    attrs: {
      "href": "https://www.reddit.com/r/ChilloutMusic",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-reddit"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "youtube",
    attrs: {
      "href": "https://www.youtube.com/channel/UCfXtga41r3-IiV7Nlm_VvKw?sub_confirmation=1",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])]), _vm._v("\n               "), _c('a', {
    staticClass: "soundcloud",
    attrs: {
      "href": "https://soundcloud.com/chilloutmusica",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-soundcloud"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('p', [_vm._v("Join us on Discord:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://discord.gg/44Mkdqh",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/social-join-discord-2.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7ac51b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 173
// module chunks = 1